import { computed, DestroyRef, inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

const ROUTES_WITHOUT_WAVE = ['overview', 'bank-wahl', 'einsicht', 'admin', 'info'];
const EINSICHT_WAVE_STEP = 4;

@Injectable({
  providedIn: 'root',
})
export class WaveService {
  readonly isWaveActive = signal(false);
  readonly einsichtStep = signal(0);
  readonly currentRoute = signal('');
  readonly isEinsichtWaveActivation = computed(
    () => this.currentRoute() === 'einsicht' && this.einsichtStep() === EINSICHT_WAVE_STEP
  );

  private readonly router = inject(Router);
  private readonly destroyRef = inject(DestroyRef);

  constructor() {
    this.router.events
      .pipe(
        filter((event): event is NavigationEnd => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe((event) => {
        this.currentRoute.set(event.url.split('/')[1]);
        this.isWaveActive.set(this.activeOnRoute(this.currentRoute()));
      });
  }

  activeOnRoute(urlCleaned: string): boolean {
    return !ROUTES_WITHOUT_WAVE.includes(urlCleaned);
  }
}
